import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
import {
  setList,
  listRequest,
  listSuccess,
  listFailure
} from './genericReducers'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  calendlyEventsListRequest: [],
  calendlyEventsListSuccess: ['list'],
  calendlyEventsListFailure: ['listError'],

  setCalendlyEvents: ['list']
})

export const CalendlyEventsTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  list: [],
  listFetching: null,
  listError: null
})

/* ------------- Reducers ------------- */

export const reset = state => state.merge(INITIAL_STATE)

/* ------------- Selectors ------------- */

export const CalendlyEventsSelectors = {}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.CALENDLY_EVENTS_LIST_REQUEST]: listRequest,
  [Types.CALENDLY_EVENTS_LIST_SUCCESS]: listSuccess,
  [Types.CALENDLY_EVENTS_LIST_FAILURE]: listFailure,

  [Types.SET_CALENDLY_EVENTS]: setList
})
